<template>
  <div v-if="isLoaded && conference_module">
    <div
        class="content-body"
        v-bind:class="{ fullscreen_expand: isFullscreen }"
    >
      <div class="row match-height">
        <div class="col-xl-12 col-lg-12">
          <div class="card" style="">
            <div class="card-header">
              <h4 class="card-title">Gestão de Inventário</h4>
              <a class="heading-elements-toggle"
              ><i
                  class="fa fa-ellipsis-v font-medium-3"
                  @click="setSubMenuShowHideFw(getSubMenuShowHideFw())"
              ></i
              ></a>
              <div
                  class="heading-elements"
                  v-bind:class="{
                  visible: getSubMenuShowHideFw(),
                  '': !getSubMenuShowHideFw(),
                }"
              >
                <ul class="list-inline mb-0">
                  <li>
                    <a
                        @click="onFilterReset()"
                        v-b-tooltip
                        title="Atualizar listagem"
                    ><i class="ft-rotate-cw"></i
                    ></a>
                  </li>
                  <li>
                    <a
                        @click="expandFullscreenFw()"
                        v-b-tooltip
                        title="Expande a tela"
                        v-if="!isFullscreen"
                    ><i class="ft-maximize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                        @click="expandFullscreenFw()"
                        v-b-tooltip
                        title="Minimiza a tela"
                        v-if="isFullscreen"
                    ><i class="ft-minimize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                        @click="onFilterShowHideFw()"
                        v-b-tooltip.hover.left="'Filtros'"
                    ><i class="fa fa-filter"></i
                    ></a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="card-content">
              <div class="table-responsive">
                <div v-if="vuetableFilterRow">
                  <vuetable-filterbar></vuetable-filterbar>
                </div>
                <div class="loadingDataPosition">
                  <div v-if="loadingData" class="loadingData">
                    <div class="loadingDataSpinner">
                      <spinner
                          v-if="loadingData"
                          text-fg-color="#ffffff"
                          message="Carregando..."
                      ></spinner>
                    </div>
                  </div>
                  <vuetable
                      :key="tableKey"
                      ref="vuetable"
                      :load-on-start="false"
                      :fields="table.columns"
                      :css="css"
                      api-url="/api/inventario/gestao"
                      :append-params="filterParams"
                      track-by="grupo_id"
                      pagination-path="meta"
                      detail-row-component="management-inventory-details"
                      @vuetable:cell-clicked="handleRowDetails"
                      no-data-template="Nenhum dado encontrado. Escolha um filtro indicado ou atualize a página."
                      @vuetable:load-error="onError"
                      @vuetable:pagination-data="onPaginationData"
                      @vuetable:loaded="onLoaded"
                      class="table-responsive-sm"
                  >
                    <template slot="actions" slot-scope="props">
                      <div class="custom-actions">
                        <a
                            @click="removeVolumeBeep(props.rowData)"
                            v-b-tooltip
                            title="Desagrupar">
                          <i class="fa fa-times"></i>
                        </a>
                        <a
                            @click="fetchUpdateStatus(props.rowData)"
                            v-b-tooltip
                            title="Mudar status">
                          <i class="fa fa-edit"></i>
                        </a>
                        <a
                            @click="handleRowDetails(props.rowData)"
                            v-b-tooltip
                            title="Ver detalhes">
                          <i class="fa fa-plus"></i>
                        </a>
                      </div>
                    </template>
                  </vuetable>
                </div>

                <div>
                  <div class="col-md-12">
                    <div class="pull-left pagination-detail">
                      <vuetable-pagination-info
                          v-if="filterApplied"
                          ref="paginationInfo"
                          :css="css.pagination"
                          info-class="pull-left"
                      ></vuetable-pagination-info>
                    </div>
                    <div class="pull-right m-a-0">
                      <vuetable-pagination
                          v-if="filterApplied"
                          ref="pagination"
                          :css="css.pagination"
                          @vuetable-pagination:change-page="onChangePage"
                      ></vuetable-pagination>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <GestaoInventarioUpdateStatusModal ref="gestaoInventarioUpdateStatusModal" @refreshTable="refreshTable"/>
    </div>
  </div>
</template>
<script>
import Vuetable from "../components/Vuetable";
import VuetablePagination from "../components/VuetablePagination";
import VuetablePaginationInfo from "../components/VuetablePaginationInfo";
import GestaoInventarioFilter from "./GestaoInventarioFilter.vue";
import {formatToBrazilianDate} from "../utils";
import GestaoInventarioUpdateStatusModal from "./GestaoInventarioUpdateStatusModal.vue";
import {ManagementStatusEnum} from "../enums/GeneralEnums";
import GestaInventarioDetails from "../components/GestaoInventarioDetails.vue";

Vue.component("management-inventory-details", GestaInventarioDetails);
export default {
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
    GestaoInventarioUpdateStatusModal,
    "vuetable-filterbar": GestaoInventarioFilter,
  },
  data() {
    return {
      tableKey: 0,
      loadingData: false,
      filterApplied: false,
      filterParams: {},
      volume_ids: [],
      form: new Form({
        volume_ids: [],
      }),
      filterForm: new Form({
        grupo_id: "",
        num_fiscal: "",
        emissor_cnpj: "",
        codigo_pedido: "",
        tipo_ocorrencia: "",
        data_inclusao: "",
        usuario_incluido_email: "",
        usuario_alterado_email: "",
        num_volume: "",
      }),
      table: {
        columns: [
          {
            name: "grupo_id",
            title: "N° do agrupamento",
          },
          {
            name: "status",
            title: "Status",
            callback: (value) => this.formatStatus(value)
          },
          {
            name: "unidade",
            title: "Unidade",
          },
          {
            name: "usuario_inclusao",
            title: "Incluido por:",
            callback: (value => value)
          },

          {
            name: "data_inclusao",
            title: "Data inclusão",
            callback: (value) => formatToBrazilianDate(value)
          },
          {
            name: "usuario_alteracao",
            title: "Alterado por:",
            callback: (value => value)
          },
          {
            name: "data_alteracao",
            title: "Data alteração",
            callback: (value) => formatToBrazilianDate(value)
          },
          {
            name: "__slot:actions",
            title: "Ações",
            titleClass: "center aligned",
            dataClass: "center aligned"
          },
        ],
      },
      css: {
        tableClass: "table",
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
      },
    };
  },
  mounted() {
    this.$events.$on("filter-reset", (e) => this.onFilterReset());
    this.$events.$on("filter-set", (eventData) => this.onFilterSet(eventData));
  },
  methods: {
    onLoaded: function () {
      this.loadingData = false;
    },
    onCreate() {
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.$refs.paginationInfo.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    confirmRemoveVolume(data) {
      this.form.volume_ids = [];
      this.loadingData = true;
      data.doc_fiscal_volume_bip.map(item => this.form.volume_ids.push(item.docfisvol_id));
      this.form
          .post(`/api/inventario/gestao/grupo/${data.grupo_id}/desagrupar`)
          .then((response) => {
            new ReturnApi(response, this, true, null, null, false)
            this.loadingData = false;
            Vue.nextTick(() => {
              if (this.$refs.vuetable) {
                this.$refs.vuetable.refresh();
              }
            });
          })
          .catch((error) => {
            new ReturnApi(error, this, true, null, null, false);
            this.loadingData = false;
            return this.$Simplert.open({
              title: "Atenção",
              message: error.message,
              customCloseBtnText: "Fechar",
              type: "error",
            })
          });
    },
    removeVolumeBeep(data) {
      this.loadingData = true;
      this.$Simplert.open({
        title: "Deseja desagrupar o volume ?",
        message: "O volume será desagrupado e voltará para tela de consulta inventário, deseja prosseguir ?",
        customCloseBtnText: "Não",
        customConfirmBtnText: "Sim",
        useConfirmBtn: true,
        type: "warning",
        onConfirm: () => this.confirmRemoveVolume(data)
      });
      this.loadingData = false;
    },
    handleRowDetails(data, field, event) {
      this.$refs.vuetable.toggleDetailRow(data.grupo_id);
    },
    fetchUpdateStatus(data) {
      this.$refs.gestaoInventarioUpdateStatusModal.onCreate(data)
    },
    onFilterSet(dataFilter) {
      this.filterApplied = true;
      this.loadingData = true;

      this.onFilterParamsChanged({
        grupo_id: dataFilter.grupo_id || null,
        num_fiscal: dataFilter.num_fiscal || null,
        emissor_cnpj: dataFilter.emissor_cnpj || null,
        codigo_pedido: dataFilter.codigo_pedido || null,
        tipo_ocorrencia: dataFilter.tipo_ocorrencia || null,
        data_inclusao: dataFilter.data_inclusao || null,
        data_inclusao_final: dataFilter.data_inclusao_final || null,
        usuario_incluido_email: dataFilter.usuario_incluido_email || null,
        usuario_alterado_email: dataFilter.usuario_alterado_email || null

      });

      Vue.nextTick(() => {
        if (this.$refs.vuetable) {
          this.$refs.vuetable.refresh();
        }
      });
      this.loadingData = false;
    },
    onFilterReset() {
      this.filterApplied = false;
      this.loadingData = true;
      this.filterParams = {};

      Vue.nextTick(() => {
        if (this.$refs.vuetable) {
          this.$refs.vuetable.resetData();
        }
        if (this.$refs.pagination) {
          this.$refs.pagination.changePage(1);
        }
        this.loadingData = false;
      });
    },
    onError(response) {
      this.loadingData = false;
    },
    onFilterParamsChanged(newFilterParams) {
      this.filterParams = {...this.filterParams, ...newFilterParams}
    },
    formatStatus(value) {
      if (value === ManagementStatusEnum.IN_NEGOTIATION) {
        return '<span class="badge badge-warning">Em negociação</span>';
      } else if (value === ManagementStatusEnum.SOLD) {
        return '<span class="badge badge-success">Vendido</span>';
      } else if (value === ManagementStatusEnum.COLLECTED) {
        return '<span class="badge badge-secondary">Coletado</span>';
      } else {
        return '<span>N/A</span>';
      }
    },
    refreshTable() {
      Vue.nextTick(() => {
        if (this.$refs.vuetable) {
          this.$refs.vuetable.reload();
        }
      });
    },
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
    isFullscreen: {
      get() {
        return this.$store.getters.is_full_screen;
      },
    },
    conference_module: {
      get() {
        return this.$store.getters.unidade_active.utiliza_modulo_conferencia;
      }
    },
  },
};
</script>
